export default [
  {
    path: '/produtoGrade/',
    name: 'produtoGrade',
    component: () => import('../views/ProdutoGradeView.vue'),
    redirect: { name: 'produtoGrade-listar' },
    children: [],
  },
];
